export { default as UnSupportedBrowserErrorBoundary } from './un-supported-browser-error-boundary';
